export const defaultDocInfo = {
  type: 'docs',
}

const SET_LOADING = 'SET_LOADING'
const GET_DOC_INFO = 'GET_DOC_INFO'
const SET_SEARCH_VALUE = 'SET_SEARCH_VALUE'
const SET_SHOW_NAV = 'SET_SHOW_NAV'

export const setLoading = (bool) => ({
  type: SET_LOADING,
  loading: bool,
})

export const getDocInfo = (info) => ({
  type: GET_DOC_INFO,
  info,
})

export const setSearchValue = (value) => ({
  type: SET_SEARCH_VALUE,
  value,
})

export const setNavShow = ({ showNav }) => ({
  type: SET_SHOW_NAV,
  showNav,
})

const initialState = {
  loading: false,
  docInfo: defaultDocInfo,
  searchValue: '',
  showNav: true,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case SET_LOADING:
      return { ...state, loading: action.loading }
    case GET_DOC_INFO:
      return { ...state, docInfo: action.info }
    case SET_SEARCH_VALUE:
      return { ...state, searchValue: action.value }
    case SET_SHOW_NAV:
      return { ...state, showNav: action.showNav }
    default:
      return state
  }
}
